import React, { useState, useEffect } from "react";
import DraggableTable from "../../Common Components/Draggable_Rows_Table";
import EventDragTable from "../../Common Components/Event_Drag_Table";
import { DragDropContext } from "react-beautiful-dnd";
import EventServiceController from "../../../Controllers/EventService";
import CalloutNamePopup from "../../Common Components/Event_Callotname_Popup";
import "react-toastify/dist/ReactToastify.css";
import CustomToaster, { notify } from "../../Common Components/Custom_Toaster";
import { Clear, Search } from "@mui/icons-material";
import Custom_InfoBar from "../../Common Components/Custom_InfoBar";
import WorkflowTemplateServiceController from "../../../Controllers/WorkflowTemplateservice";
import { IconButton, } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import EventConfirmPopup from "../../Common Components/Event_Confirm_Popup";
import { appConstants } from "../../../Pages/AppConstants";

const EventList = ({ handleEventEditClick, eventCalloutName, primaryEventSearchText, selectedEventSearchText, eventSearchClear, handleSearchChange, toolTipData }) => {
  const [selectedIds, setSelectedIds] = React.useState([]);

  const sourceTableHeading = ["", "Level", "Event name"];
  // const destTableHeading = ["", "Event name", "Callout Name", ""];
  const destTableHeading = ["", "Event Name"];

  const [listTableRows, setListTableRows] = useState([]);
  const [eventTableRows, setEventTableRows] = useState([]);
  const [shouldReload, setShouldReload] = useState(false);
  const [isOpenCalloutNamePop, setIsOpenCalloutNamePop] = useState(false);
  const [updatedDestRows, setUpdatedDestRows] = useState([]);
  const [calloutName, setCalloutName] = useState(eventCalloutName);
  const [editingItemIndex, setEditingItemIndex] = useState(null);
  const [latestIndex, setLatestIndex] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);
  const [legend, setLegend] = useState([
    // { name: "Menu", color: "#FF5733" },
    // { name: "Status", color: "#33FF57" },
    // { name: "Others", color: "#3357FF" },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmPopupData, setConfirmPopupData] = useState({
    title: 'Confirmation',
    popupType: 'Save',
    name: 'Changes will be discarded if you cancel?'
  });
  const [pendingLevel, setPendingLevel] = useState(null);
  const [name, setName] = useState("");
  const eventCont = new EventServiceController();
  var Spinner = require('react-spinkit');

  const workflowTempCont = new WorkflowTemplateServiceController();
  const [workflowLevelComp, setWorkflowLevelComp] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [deleteActive, setDeleteActive] = useState(false);
  const hasMultipleSelection = selectedIds.length >= 1;

  const getSidebarLevelComponents = async () => {
    const body = await workflowTempCont.getSidebarComponents();
    console.log(body);
    setWorkflowLevelComp(
      Array.isArray(body) && body.length > 0 ?
        body.map((levelComp, index) => ({
          id: levelComp.id,
          levelCode: levelComp.levelCode,
          levelName: levelComp.levelName,
          mappedsubflowId: levelComp.mappedSubflowId,
        })
        )
        :
        []
    )
  }

  const getPrimaryEventsData = async () => {
    const body = await eventCont.getPrimaryEventsList();
    console.log(body);

    if (Array.isArray(body) && body.length > 0) {
      // Sort by numeric part of eventLevel (e.g., 'L10' -> 10)
      const sortedBody = body.sort((a, b) => {
        const aLevel = parseInt(a.eventLevel.replace(/\D/g, ""), 10); // Extract number
        const bLevel = parseInt(b.eventLevel.replace(/\D/g, ""), 10);
        return aLevel - bLevel;
      });

      setListTableRows(
        body.map((item, index) => ({
          sNo: index + 1,
          eventLevel: item.eventLevel,
          eventName: item.eventCode,
          eventId: item.id,
          eventColor: item.typeColor,
          eventType: item.typeName,
          eventCode: item.eventName,
        }))
      );

      // Extract unique types for legend as before
      const uniqueTypes = Array.from(new Set(sortedBody.map((item) => item.typeName)))
        .map((typeName) => {
          const item = sortedBody.find((item) => item.typeName === typeName);
          return {
            name: typeName,
            color: item.typeColor,
            level: item.eventLevel,
          };
        });

      setLegend(() => [...uniqueTypes]);
    } else {
      setListTableRows([]);
    }
  };

  const getSecondaryEventsData = async (newValue) => {
    const ClientId = appConstants.clientId;
    const body = await eventCont.getSecondaryEventsList(newValue);
    const mappedRows =
      Array.isArray(body) && body.length > 0
        ? body.map((item, index) => ({
          sNo: `E-${index + 1}`,
          primaryEventName: item.displayName,
          primaryEventId: item.primaryEventId,
          primaryEventCode: item.primaryEventCode,
          callOutName: item.calloutName,
          eventId: item.id,
          publish: item.isPublished ? "published" : "publish",
          wflevelId: newValue,
          clientId: ClientId,
          createdDate: item.createdDate,
          modifiedDate: item.modifiedDate,
        }))
        : [];
    setEventTableRows(mappedRows);
  };

  const getLastModifiedDate = (rows) => {
    if (!rows || rows.length === 0) return ""; // no rows, empty string

    // Find the latest date among all rows
    const latestDate = rows.reduce((latest, row) => {
      const rowDate = row.modifiedDate ? new Date(row.modifiedDate) : new Date(row.createdDate);
      return rowDate > latest ? rowDate : latest;
    }, new Date(0)); // start from epoch

    // Format as DD/MM/YYYY HH:mm
    const day = String(latestDate.getDate()).padStart(2, "0");
    const month = String(latestDate.getMonth() + 1).padStart(2, "0"); // months start from 0
    const year = latestDate.getFullYear();
    //const hours = String(latestDate.getHours()).padStart(2, "0");
    let hours = latestDate.getHours();
    const minutes = String(latestDate.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
  };

  const fetchData = async () => {
    setIsProcessing(true);
    await getPrimaryEventsData();
    //await getSecondaryEventsData();
    setIsProcessing(false);
    setShouldReload(false);
  }

  useEffect(() => {
    fetchData();
  }, [shouldReload]);

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result.map((item, index) => ({
      ...item,
      sNo: `E-${index + 1}`,
    }));
  };

  const transformItemForDestination = (item) => {
    return {
      ...item,
      callOutName: calloutName, // Add new column data
      publish: "publish",
      menu: "",
    };
  };

  // ======================== onCalloutNameSave ========================
  const onCalloutNameSave = (eventId) => {
    console.log("Saving callout name for eventId:", eventId, calloutName);
    setEventTableRows((prevRows) => {
      const updatedRows = prevRows.map((row) =>
        row.eventId === eventId
          ? { ...row, callOutName: calloutName }
          : row
      );
      return updatedRows;
    });

    setIsOpenCalloutNamePop(false);

    // Find the updated row by eventId
    const updatedRow = updatedDestRows.find(r => r.eventId === eventId);
    if (!updatedRow) return;

    const primaryEventId = updatedRow.eventId;
    // Append level to the callout name
    const primaryCalloutName = `${updatedRow.eventName} (${updatedRow.eventLevel})`;
    updateRowsAPI({
      clientId: 72,
      primaryEventId: primaryEventId,
      calloutName: primaryCalloutName,
    });
  };

  const handleOnDragEnd = (result) => {
    if (selectedLevel === undefined || selectedLevel === null || selectedLevel === "") {
      notify("Please select the recruitment level.", false);
      return;
    }

    const { source, destination } = result;
    if (!destination) return;

    // ================= Reorder inside Selected Events =================
    if (source.droppableId === destination.droppableId) {
      if (source.droppableId === "eventTable") {
        const reorderedList = reorder(
          eventTableRows,
          source.index,
          destination.index
        );
        setEventTableRows(reorderedList);
      }
      return;
    }

    // ================= Primary → Selected =================
    if (source.droppableId === "listTable" && destination.droppableId === "eventTable") {
      const sourceItem = filteredPrimaryEvents[source.index];
      // 🔹 Build row ONCE (this is the key)
      const isDuplicate = eventTableRows.some(
        (row) =>
          row.primaryEventName?.toLowerCase() ===
          sourceItem.eventName?.toLowerCase()
      );

      if (isDuplicate) {
        notify(`This event name '${sourceItem.eventName}' is already added.`, false);
        return;
      }
      const ClientId = appConstants.clientId;
      const newItem = {
        ...sourceItem,
        primaryEventId: sourceItem.eventId,
        callOutName: `${sourceItem.eventName} (${sourceItem.eventLevel})`,
        publish: "true",
        wflevelId: selectedLevel,
        primaryEventName: sourceItem.eventName,
        primaryEventCode: sourceItem.eventName,
      };
      // 🔹 Insert into selected list
      const updatedRows = [...eventTableRows];
      updatedRows.splice(destination.index, 0, newItem);

      const finalRows = updatedRows.map((item, index) => ({
        ...item,
        sNo: `E-${index + 1}`,
        clientId: ClientId,
      }));

      // 🔹 Update UI
      setEventTableRows(finalRows);
      setIsOpenCalloutNamePop(false);
      setCalloutName(newItem.callOutName);
      setDeleteActive(true);
    }

    /* ================= eventTable → listTable ================= */
    if (source.droppableId === "eventTable" && destination.droppableId === "listTable") {
      const sourceItem = eventTableRows[source.index]; // ✅ FIXED
      var eventId = sourceItem.eventId;
      deleteSecondaryEvent(eventId);
    }
  };

  const resetAll = async () => {
    if (selectedLevel == "" && selectedEventSearchText == "") {
      return;
    }
    setDeleteActive(false);
    setSelectedIds([]);
    eventSearchClear("selectedEvent")
    setSelectedLevel([]);
    await getSecondaryEventsData(pendingLevel);
    notify("Reset successfully.", false);
  }

  const updateRowsAPI = async () => {
    if (selectedLevel == "") {
      notify("Please select Recruitment stage.", false);
      return false;
    }
    setIsProcessing(true);
    const body = await eventCont.addUpdateSecondaryEvents(eventTableRows);
    if (body === "Saved Successfully!") {
      notify(
        `Events has been successfully saved.`,
        true
      );
      //fetchData();
      await getSecondaryEventsData(selectedLevel);
    } else {
      notify(
        "There was an error while adding primary event to the secondary. Please try again later...",
        false
      );
      deleteRowByIndex(latestIndex);
    }
    setIsProcessing(false);
    setDeleteActive(false);
    setSelectedIds([]);
  };

  useEffect(() => {
    getSidebarLevelComponents();
  }, []);

  const onClose = () => {
    setIsOpenCalloutNamePop(false);
    deleteRowByIndex(latestIndex);
  };

  const handleInputChange = (event) => {
    setCalloutName(event.target.value);
  };

  const deleteRowByIndex = (indexToDelete) => {
    setUpdatedDestRows((rows) =>
      rows.filter((_, index) => index !== indexToDelete)
    );
    setShouldReload(true);
  };

  const publishSecondaryEvent = (id) => {
    setIsLoading(true);
    setTimeout(async () => {
      const body = await eventCont.publishSecondaryEvents(id);
      setIsLoading(false);
      closePopupOnFinishingApiCall();
      body["Success"]
        ? notify(`${name} has been successfully published`, true)
        : notify(
          "There was an error while performing publishing operation. Please try again later...",
          false
        );
    }, 1000);
  };

  const deleteSecondaryEvent = (eventId) => {
    setEventTableRows(prevRows => {
      const updatedRows = prevRows.filter(
        row => String(row.eventId) !== String(eventId)
      );
      return updatedRows.map((item, index) => ({
        ...item,
        sNo: `E-${index + 1}`,
      }));
    });
    setIsPopupOpen(false);
    notify("Event Successfully Moved.", true);
    setDeleteActive(true);
  };

  const handleBulkDelete = () => {
    setEventTableRows(prevRows =>
      prevRows
        .filter(row => !selectedIds.includes(row.eventId))
        .map((item, index) => ({
          ...item,
          sNo: `E-${index + 1}`,
        }))
    );
    setIsPopupOpen(false);
    notify("Events Successfully Removed.", true);
    setSelectedIds([]);
    setDeleteActive(true);
  };

  const closePopupOnFinishingApiCall = () => {
    setIsPopupOpen(false);
    setShouldReload(true);
  };

  const filteredPrimaryEvents = listTableRows.filter(event => event.eventName.toLowerCase().includes(primaryEventSearchText.toLowerCase()));
  const filteresSelectedEvents = eventTableRows.filter(event => event.callOutName.toLowerCase().includes(selectedEventSearchText.toLowerCase()));
  const [isInfoBarVisible, setIsInfoBarVisible] = useState(true);
  const handleHideInfoBar = () => {
    setIsInfoBarVisible(!isInfoBarVisible);
  }

  useEffect(() => {
    console.log("Updated selectedIds:", selectedIds);
  }, [selectedIds]);

  const handleEventCheckboxChange = (item) => {
    const eventId = Number(item.eventId);
    setSelectedIds((prev) =>
      prev.includes(eventId)
        ? prev.filter((id) => id !== eventId)
        : [...prev, eventId]
    );
    console.log("Updated selectedIds:", selectedIds);
  };

  // ----- Header Checkbox -----
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = eventTableRows.map((row) => Number(row.eventId));
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
    return;
  };

  // Inside your component, after useState hooks
  // ----------------- Highlight function -----------------
  const highlightText = (text, search) => {
    if (!search) return text;
    const regex = new RegExp(`(${search})`, "gi");
    const parts = text.split(regex);
    return parts.map((part, i) =>
      regex.test(part) ? (
        <span key={i} style={{ backgroundColor: "#FFFF00" }}>{part}</span>
      ) : (
        part
      )
    );
  };

  // ----------------- Map rows with highlight -----------------
  const highlightedSelectedEvents = eventTableRows.map((row) => ({
    ...row,
    primaryEventName: highlightText(row.primaryEventName, selectedEventSearchText),
    callOutName: highlightText(row.callOutName, selectedEventSearchText),
  }));

  useEffect(() => {
  }, [confirmPopupData]);

  const openPopup = () => {
    setIsPopupOpen(!isPopupOpen);
    setName(name);
  };

  const openPopupEvent = () => {
    setIsPopupOpen(!isPopupOpen);
    setConfirmPopupData({
      popupType: 'save',
      name: 'name'
    });
    setName(name);
  };

  const handleCancel = async () => {
    setIsLoading(true);
    eventSearchClear("selectedEvent");
    setSelectedIds([]);
    setSelectedLevel(pendingLevel);
    await getSecondaryEventsData(pendingLevel);
    setPendingLevel(null);
    setIsPopupOpen(false);
    setDeleteActive(false);
  };

  const handleSave = () => {
    setIsLoading(true);
    setSelectedLevel(pendingLevel);
    updateRowsAPI();
    setIsPopupOpen(false);
    setPendingLevel(null);
    setDeleteActive(false);
  };

  return (
    <>
      <style>
        {`
          input::placeholder {
            color: #cfd4e9;
          }
        `}
      </style>
      {
        isProcessing ?
          <>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80%' }}>
              <Spinner name="ball-spin-fade-loader" color="#02acf6" />
            </div>
          </> :
          <>
            <DragDropContext onDragEnd={handleOnDragEnd}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "97%",
                  padding: "0px 20px",
                  marginTop: "15px",
                }}
              >
                <div
                  style={{ display: "flex", flexDirection: "column", width: "33%", height: "725px", }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginLeft: "30px",
                      marginTop: "15px",
                      width: "100%",
                    }}
                  >
                    <p style={{ fontSize: "20px", fontWeight: 'bold', fontFamily: 'Montserrat,sans-serif', }}>
                      Global Events ({filteredPrimaryEvents.length})
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #cfd4e9', borderRadius: '4px', }}>
                      <input
                        type="text"
                        placeholder="Search..."
                        value={primaryEventSearchText}
                        onChange={(event) => handleSearchChange('primaryEvent', event)}
                        style={{ height: "38px", width: "80%", border: 'none', borderRadius: '4px', outline: 'none' }}
                      />
                      {/* <img src={(primaryEventSearchText === ''|| selectedEventSearchText === undefined)? searchIcon : closeIcon} alt="search-icons" onClick={()=>eventSearchClear('primaryEvent')}/> */}
                      {(primaryEventSearchText === '' || primaryEventSearchText === undefined) ? <Search style={{ color: '#757ea5' }} /> : <Clear style={{ color: '#757ea5' }} onClick={() => eventSearchClear('primaryEvent')} sx={{ cursor: 'pointer' }} />}
                    </div>

                  </div>
                  <DraggableTable
                    row={filteredPrimaryEvents}
                    heading={sourceTableHeading}
                    template={false}
                    workflow={false}
                    event={true}
                    task={false}
                    droppableId="listTable"
                    globalEvent={true}
                  />

                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "65%",
                    minHeight: "400px",
                    maxHeight: "calc(100vh - 120px)",
                    overflowY: "auto",      // ✅ vertical scroll only
                    overflowX: "hidden",    // ✅ prevent horizontal scroll
                    boxSizing: "border-box"
                  }}
                >
                  {/* ROW 1: Title + Search */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginLeft: "30px",
                      marginTop: "15px",
                      paddingRight: "20px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "20px",
                        fontWeight: "bold",
                        fontFamily: "Montserrat,sans-serif",
                      }}
                    >
                      Selected Events ({eventTableRows.length})
                    </p>

                    {/* SEARCH BAR (RIGHT SIDE) */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        border: "1px solid #cfd4e9",
                        borderRadius: "4px",
                        padding: "0 8px",
                        width: "260px",

                      }}
                    >
                      <input
                        type="text"
                        placeholder="Search..."
                        value={selectedEventSearchText}
                        onChange={(event) => handleSearchChange("selectedEvent", event)}
                        style={{
                          height: "35px",
                          width: "100%",
                          border: "none",
                          outline: "none",
                        }}
                      />
                      {(selectedEventSearchText === "" || selectedEventSearchText === undefined) ? (
                        <Search style={{ color: "#757ea5" }} />
                      ) : (
                        <Clear
                          style={{ color: "#757ea5", cursor: "pointer" }}
                          onClick={() => eventSearchClear("selectedEvent")}
                        />
                      )}

                    </div>
                  </div>

                  {/* ROW 2: Recruitment stage + Last Modified */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginLeft: "30px",
                      marginTop: "10px",
                      paddingRight: "20px",
                    }}
                  >
                    {/* Recruitment stage */}
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <span
                        style={{
                          fontSize: "15px",
                          fontWeight: "bold",
                          fontFamily: "Montserrat,sans-serif",
                          whiteSpace: "nowrap",
                        }}
                      >
                        Recruitment stage
                      </span>

                      <select
                        value={selectedLevel}
                        onChange={async (e) => {
                          const newValue = e.target.value;
                          if (deleteActive) {
                            setPendingLevel(newValue);
                            setIsPopupOpen(true);
                          } else {
                            setSelectedLevel(newValue);
                            getSecondaryEventsData(newValue);
                          }
                        }}

                        style={{
                          height: "35px",
                          width: "180px",
                          border: "1px solid #cfd4e9",
                          borderRadius: "4px",
                          outline: "none",
                        }}
                      >
                        <option value="">Select</option>
                        {workflowLevelComp.map((item) => (
                          <option key={item.id} value={item.id}>
                            {item.levelName}
                          </option>
                        ))}
                      </select>

                      <Tooltip title="Select at least one event to delete">
                        <span>
                          <IconButton
                            disabled={!hasMultipleSelection}
                            onClick={handleBulkDelete}
                            sx={{
                              color: hasMultipleSelection ? "error.main" : "grey.400"
                            }}
                          >
                            <DeleteIcon />
                          </IconButton>
                        </span>
                      </Tooltip>

                    </div>

                    {/* Last Modified (RIGHT SIDE) */}
                    <span style={{ fontSize: "13px", fontFamily: "Montserrat,sans-serif", whiteSpace: "nowrap" }}>
                      <span style={{ fontWeight: "bold", color: "#000000" }}>Last Modified: </span>
                      <span style={{ fontWeight: "bold", color: "#02ACF6" }}>
                        {getLastModifiedDate(eventTableRows)}
                      </span>
                    </span>

                  </div>

                  {/* TABLE */}
                  <EventDragTable
                    row={highlightedSelectedEvents}
                    openPopup={openPopup}
                    heading={destTableHeading}
                    noEvent={eventTableRows.length === 0}
                    droppableId="eventTable"
                    handleEditClick={handleEventEditClick}
                    handleCheckboxChange={handleEventCheckboxChange}
                    handleSelectAll={handleSelectAll}
                    selectedIds={selectedIds}
                  />
                  {/* SAVE & RESET BUTTONS */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "10px", // space between buttons
                    }}
                  >
                    <button
                      className="submit-btn"
                      style={{ width: "140px", background: "#000000" }}
                      onClick={resetAll}
                    >
                      Cancel
                    </button>
                    <button
                      className="submit-btn"
                      style={{ width: "140px" }}
                      onClick={updateRowsAPI}
                    >
                      Save
                    </button>
                  </div>
                </div>
                
              </div>
            </DragDropContext>
          </>
      }

      <CalloutNamePopup
        open={isOpenCalloutNamePop}
        onClose={onClose}
        onSave={onCalloutNameSave}
        handleInputChange={handleInputChange}
      />

      <EventConfirmPopup
        openConfirmationPopup={isPopupOpen}
        onClose={openPopupEvent}
        handleCancel={handleCancel}
        handleSave={handleSave}
        isLoading={isLoading}
        popupData={confirmPopupData}
      />
      <CustomToaster />
    </>
  );
};

export default EventList;
